import styled from 'styled-components';
import Wra16A from 'dc/Wra16A';
import { Typ20, Typ31 } from 'dc/Typ';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const WrapperStd = styled(Wra16A)`
  background-color: #ffffff;
  width: 100%;
  flex-direction: column;
`;

export const Title = styled(Typ31)`
  width: 100%;
  max-width: 500px;
  color: #263238;
  margin-bottom: 8px;
`;

export const Text = styled(Typ20)`
  width: 100%;
  max-width: 500px;
  color: #263238;
  overflow-wrap: break-word;
  margin-bottom: 32px;

  &:last-child {
    margin-bottom: 24px;
  }
`;

export const SponsorList = styled.ul`
  padding-left: 25px;
  margin-top: 0;
`;

export const SponsorLink = styled.a`
  :link {
    color: rgba(0, 61, 68, 1);
  }
`;
